/**
 * Shared IndexedDB store identifiers for the page-side `storage.web.ts`
 * adapter and the service worker's direct `idb-keyval.get()` calls.
 *
 * Lives in its own module so the SW can import the constants without
 * pulling in `storage.web.ts`'s side effects (BroadcastChannel
 * instantiation, listener registration, the `_resetForTests` symbol,
 * and the transitive `@reflecto/client-core` types). Bundling those
 * into the SW would silently inflate `dist/sw.js` and risk SW-context
 * crashes for any future page-only API the adapter starts to use.
 *
 * idb-keyval's default store is a SEPARATE IndexedDB database
 * (`keyval-store` / `keyval`) on the same origin, so the page and the
 * SW must agree on these literals exactly. A rename here is a compile
 * error in both consumers — exactly the failure mode an earlier review
 * cycle flagged when these strings were duplicated.
 */
export const REFLECTO_IDB_DB_NAME = "reflecto";
export const REFLECTO_IDB_STORE_NAME = "kv";
